import React from "react";

const css = `
@keyframes eds-spin { to { transform: rotate(360deg); } }
`;

export default function Spinner({ size = 14, color = "currentColor" }) {
  return (
    <span aria-hidden="true" style={{ display: "inline-block", lineHeight: 0 }}>
      <style>{css}</style>
      <svg width={size} height={size} viewBox="0 0 24 24" style={{ animation: "eds-spin 0.9s linear infinite" }}>
        <circle cx="12" cy="12" r="10" style={{ stroke: color }} strokeWidth="2.5" fill="none" strokeLinecap="round" strokeDasharray="40 80" />
      </svg>
    </span>
  );
}
